module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "TITLE"
  }, [_c('a', {
    attrs: {
      "id": "_idTOCAnchor-1"
    }
  }), _vm._v("Called to the Life of the Mind")]), _vm._v(" "), _c('p', {
    staticClass: "SUBTITLE"
  }, [_vm._v("Some Advice for Evangelical Scholars")]), _vm._v(" "), _c('p', {
    staticClass: "AUTHOR"
  }, [_vm._v("Richard J. Mouw")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenPageitem-2"
  }, [_c('img', {
    staticClass: "_idGenPageitem-1",
    attrs: {
      "alt": "",
      "src": "image/COMPASS.jpg"
    }
  })])]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "COMPANY"
  }, [_c('span', {
    staticClass: "sc"
  }, [_vm._v("William B. Eerdmans Publishing Company"), _c('br')]), _vm._v("Grand Rapids, Michigan / Cambridge, U.K.")]), _vm._v(" "), _c('p', {
    staticClass: "COPYRIGHT"
  }, [_vm._v("© 2014 Richard J. Mouw"), _c('br'), _vm._v("All rights reserved"), _c('br'), _c('br'), _vm._v("Published 2014 by"), _c('br'), _c('span', {
    staticClass: "sc"
  }, [_vm._v("Wm. B. Eerdmans Publishing Co."), _c('br')]), _vm._v("2140 Oak Industrial Drive "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("n.e.,")]), _vm._v(" Grand Rapids, Michigan 49505 /"), _c('br'), _c('span', {
    staticClass: "sc"
  }, [_vm._v("p.o. ")]), _vm._v("Box 163, Cambridge "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("cb3 9pu")]), _vm._v(" U.K."), _c('br'), _c('br'), _vm._v("Printed in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "LIBRARY"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "CIP"
  }, [_vm._v("Mouw, Richard J."), _c('br'), _vm._v("Called to the life of the mind:"), _c('br'), _vm._v("some advice for evangelical scholars / Richard J. Mouw."), _c('br'), _vm._v("pages   cm"), _c('br'), _c('span', {
    staticClass: "sc"
  }, [_vm._v("isbn")]), _vm._v(" 978-0-8028-6766-7 (pbk.: alk. paper)"), _c('br'), _c('span', {
    staticClass: "sc"
  }, [_vm._v("eisbn")]), _vm._v(" 978-1-4674-4222-0 (ePub)"), _c('br'), _c('span', {
    staticClass: "sc"
  }, [_vm._v("eisbn")]), _vm._v(" 978-1-4674-4188-9 (Kindle)"), _c('br'), _vm._v("1. Theology — Study and teaching — United States."), _c('br'), _vm._v("2. Evangelicalism — United States. 3. Mouw, Richard J."), _c('br'), _vm._v("4. Theologians. I. Title."), _c('br'), _c('br'), _vm._v("BV4030.M68 2014"), _c('br'), _vm._v("230"), _c('span', {
    staticClass: "symbol"
  }, [_vm._v("′")]), _vm._v(".046240973 — dc23"), _c('br'), _vm._v("                 2014033463")]), _vm._v(" "), _c('p', {
    staticClass: "URL"
  }, [_c('a', {
    attrs: {
      "href": "http://www.eerdmans.com",
      "target": "_blank"
    }
  }, [_vm._v("www.eerdmans.com")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54da8f60","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Mouw_Called_to_the_Life_of_the_Mind_text_CC1.vue
// module id = 60
// module chunks = 0